export default __webpack_public_path__ + "static/media/Roboto-LightItalic.43cbee78.ttf";